import React from 'react'
import { AreaItem } from '@/types/cms/AreaItem'
import DynamicRenderer from '@/elements/DynamicRenderer'
import registry from './StorylineElements'
import AppContext from '@/types/context'

interface ArticleDetailDefaultProps {
  item: AreaItem | any
  context: AppContext
}

const Index: React.FC<ArticleDetailDefaultProps> = ({ context, item }) => (
  <>
    {item.items?.map((item: AreaItem, index: number) => (
      <DynamicRenderer key={item.id ?? index} name={item.type} registry={registry} context={context} item={item} />
    ))}
  </>
)

export default Index
